import React from 'react';

import { connect } from 'react-redux';

class StarIcon extends React.Component {

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    return (
      <svg style={this.props.style} onClick={this.handleClick.bind(this)}>
        <polygon
     fill={this.props.checked ? (this.props.color || "#DE171F") : '#F6F6F6'}
     stroke={'#000000'}
     points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "
     id="polygon3"
     transform="matrix(0.40841331,0,0,0.40841331,0.50000012,0.50000012)" />
      </svg>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, undefined)(StarIcon);



// WEBPACK FOOTER //
// ./src/icons/star.js